import React from 'react';
import FolderDoc from '../Components/Folders/FolderDoc';
import NestedFolders from '../Components/Folders/NestedFolders'

const FolderDocuments = () => {
    return (
        <div>
            <NestedFolders/>
            <FolderDoc />
        </div>
    );
};

export default FolderDocuments;